var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgPronouns = function SvgPronouns(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86853 5.69995C5.4012 6.51497 4.41016 8.06611 4.41016 9.8456C4.41016 12.4714 6.56797 14.6 9.22977 14.6C10.9512 14.6 12.4618 13.7097 13.3143 12.3705",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8987 9.40369C13.8987 9.40369 9.79688 7.04797 9.79688 4.18746C9.79696 3.68187 9.96778 3.19193 10.2803 2.80091C10.5928 2.4099 11.0277 2.14195 11.5111 2.04263C11.9945 1.94331 12.4965 2.01875 12.9318 2.25612C13.3671 2.49348 13.7087 2.87813 13.8987 3.34466L13.8987 3.34466C14.0887 2.87813 14.4304 2.49349 14.8657 2.25612C15.301 2.01875 15.803 1.94331 16.2863 2.04263C16.7697 2.14195 17.2047 2.4099 17.5172 2.80091C17.8297 3.19193 18.0005 3.68187 18.0006 4.18746C18.0006 7.04797 13.8987 9.40369 13.8987 9.40369Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.9999C2.83671 16.9405 3.88155 16.0887 5.06111 15.5042C6.24067 14.9198 7.52635 14.6169 8.8278 14.6169C10.1293 14.6169 11.4149 14.9198 12.5945 15.5043C13.7741 16.0887 14.8189 16.9406 15.6556 18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgPronouns;